import {
    combineReducers,
    configureStore,
} from "@reduxjs/toolkit"
import {
    persistReducer,
    persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist"
import storage from "redux-persist/lib/storage"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import authSlice from "./slices/authSlice"
import jobSlice from "./slices/jobSlice"
import headerMiddleware from "./middleware/headerMiddleware"



const rootReducer = combineReducers({
    auth: authSlice,
    job: jobSlice
})

const persistConfig = {
    key: "neisolsayaparim-config",
    storage: storage,

}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).concat(headerMiddleware),
})

export const persistor = persistStore(store)


export type RootState = ReturnType<typeof persistedReducer>;
export type AppDispatch = typeof store.dispatch;

type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// async function resetStore() {
//   await persistor.purge();
//   window.location.reload();
// }
// //
// resetStore();
